export interface AnalysisRequestDTO { model_id: string; parameters: Record<string, unknown>; }
export interface AnalysisResponseDTO { model_id: string; rows: number; results: Record<string, unknown>[]; duration_ms: number; }

const BASE = '/api';

export async function runAnalysis(req: AnalysisRequestDTO): Promise<AnalysisResponseDTO> {
  const r = await fetch(`${BASE}/tess/analysis`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(req)
  });
  if (!r.ok) {
    throw new Error(`Analysis failed: ${r.status}`);
  }
  return r.json();
}
